import { adjectives } from './adjectives'
import { nouns } from './nouns'
import { getPhrase } from './get-phrase'

document.addEventListener(`DOMContentLoaded`, () => {
    document.getElementById("phrase").innerText = getPhrase(adjectives, nouns)
})
